import { render, staticRenderFns } from "./CoverTypeSelection.vue?vue&type=template&id=6fc51154"
import script from "./CoverTypeSelection.vue?vue&type=script&lang=js"
export * from "./CoverTypeSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports